import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { ComumService } from '../../comum/comum.service';
import { AuthService } from '../../auth/auth.service';
import { PermissoesAcessoService } from '../permissoes-acesso.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { CookieService } from 'angular2-cookie';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Usuario } from '../../comum/modelos/usuario';
import { UsuarioArea } from '../../comum/modelos/usuario-area';
import { AreaCliente } from '../../comum/modelos/area-cliente';
import { ClienteService } from '../../cliente/cliente.service';

@Component({
    selector: 'app-listar-usuarios-filtro-area',
    templateUrl: './listar-usuarios-filtro-area.component.html',
    styleUrls: ['./listar-usuarios-filtro-area.component.css']
})
export class ListarUsuariosFiltroAreaComponent implements OnInit {

    @Output() usuarioAreaEvent: EventEmitter<UsuarioArea[]>;
    usuariosArea: UsuarioArea[];
    areasCliente: AreaCliente[];
    usuarioSelecionado: Usuario;
    idAreaCliente: number;

    paginacao: Paginacao;

    selecionados: boolean;
    statusCode: number;

    public loading = false;

    constructor (private _comumService: ComumService,
        private _permissoesAcessoService: PermissoesAcessoService,
        private _usuarioService: UsuarioService,
        private _clienteService: ClienteService,
        private _cookieService: CookieService,
        private _authService: AuthService) {
        this.paginacao = new Paginacao();
        this.usuarioSelecionado = new Usuario();
        this.usuariosArea = new Array<UsuarioArea>();
        this.areasCliente = new Array<AreaCliente>();
        this.usuarioAreaEvent = new EventEmitter<UsuarioArea[]>();
    }

    ngOnInit() {
        this.paginacao.itens = 5;
        this.paginacao.page = 1;
        this.loading = true;
        const idCliente = parseInt(this._cookieService.get('idCliente'), 10);

        this._clienteService.obterAreasClienteHttp(idCliente)
            .subscribe((areasCliente) => {
                this.areasCliente = areasCliente;
                this.loading = false;
            });
    }

    selecionarArea() {
        this.usuariosArea = new Array<UsuarioArea>();
        const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
        forkJoin(this._permissoesAcessoService.obterAreasUsuario(this.idAreaCliente),
            this._clienteService.obterAreasClienteHttp(idCliente),
            this._usuarioService.obterUsuariosHttp(idCliente))
            .subscribe(([areasUsuario, areasCliente, usuarios]) => {
                this.areasCliente = areasCliente;
                for (const usuario of usuarios) {
                    const usuarioArea = new UsuarioArea();
                    usuarioArea.usuario = usuario;
                    usuarioArea.idAreaCliente = this.idAreaCliente;
                    for (const areaUsuario of areasUsuario) {
                        if (usuario.idUsuario === areaUsuario.usuario.idUsuario) {
                            usuarioArea.idUsuarioArea = areaUsuario.idUsuarioArea;
                            usuarioArea.selecionado = true;
                            break;
                        }
                    }
                    this.usuariosArea.push(usuarioArea);
                }
            });
    }

    selecionar(usuarioArea: UsuarioArea, event): void {
        usuarioArea.selecionado = !usuarioArea.selecionado;
        usuarioArea.alterado = true;
    }

    selecionarTodos(): void {
        this.selecionados = !this.selecionados;
        this.usuariosArea.forEach(usuarioArea => {
            usuarioArea.selecionado = this.selecionados;
            usuarioArea.alterado = true;
        });
    }

    emit(): void {
        this.loading = true;
        const usuariosAreaInsert = new Array<UsuarioArea>();
        const usuariosAreaRemove = new Array<UsuarioArea>();
        this.usuariosArea.forEach(usuarioArea => {
            if (!usuarioArea.selecionado && usuarioArea.idUsuarioArea !== undefined && usuarioArea.alterado) {
                usuariosAreaRemove.push(usuarioArea);
            } else if (usuarioArea.selecionado && usuarioArea.idUsuarioArea === undefined && usuarioArea.alterado) {
                usuariosAreaInsert.push(usuarioArea);
            }
        });
        if (usuariosAreaRemove.length > 0) {
            this._permissoesAcessoService.removerUsuariosAreaHttp(usuariosAreaRemove)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                    this.usuarioAreaEvent.emit(this.usuariosArea);
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
        if (usuariosAreaInsert.length > 0) {
            this._permissoesAcessoService.cadastrarUsuariosAreaHttp(usuariosAreaInsert)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                    this.usuarioAreaEvent.emit(this.usuariosArea);
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
        this.loading = false;
        this.usuarioAreaEvent.emit(this.usuariosArea);
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/permissoes-acesso/listar-usuarios-filtro-area/listar-usuarios-filtro-area.component.ts